import ListErrors from '../components/ListErrors'
import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import {
    UPDATE_FIELD_AUTH,
    VERIFY_USER_PIN,
    VERIFY_PIN_CODE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    currentUser: state.common.currentUser,
    errors: state.common.errors,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onChangeCode: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'code', value }),
    onCheckUserPinCode: (payload) => {
        dispatch({ type: VERIFY_USER_PIN, payload })
    },
    onUnload: () =>
        dispatch({ type: VERIFY_PIN_CODE_UNLOADED })
})

class VerifiyPin extends React.Component {
    constructor() {
        super()
        this.state = {
            code: '',
        }
        this.changeCode = ev => this.props.onChangeCode(ev.target.value)
        this.checkUserPinCode = (code) => ev => {
            ev.preventDefault()
            console.log(this.props.currentUser.token)
            const payload = agent.Auth.verifyUserPin(this.props.currentUser.token, this.props.currentUser.key, code);
            this.props.onCheckUserPinCode(payload)
        }
    }
    // componentWillMount(props) {
    //     if (this.props.userKey) {
    //         Object.assign(this.state, {
    //             userKey: this.props.userKey,
    //             phone: this.props.phone,
    //         })
    //     }
    // }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        const code = this.props.code || ''
        const inProgress = this.props.inProgress
        return (
            <div className="notice">
                <h1>Pin Code</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.checkUserPinCode(code)}>
                    <fieldset className="form">
                        <fieldset className="form-group">
                            <input
                                type="password"
                                placeholder="code"
                                value={code}
                                maxLength={4}
                                onChange={this.changeCode} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Sign in
                  </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifiyPin)



// WEBPACK FOOTER //
// ./src/components/VerifiyPin.js